import { getRankImage } from "../../utils/permissions";
 
const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";

export const videoBaseUrl = isLocalhost
  ? "/lib/videos/" 
  : ""  //"https://d2ytlht1oeujr4.cloudfront.net/";

export const docBaseUrl = "/lib/docs/";       
export const utilBaseUrl = "/lib/utils/";   


export const levelContentData = [
  { rank: getRankImage(0),
    level : 0,
    title: "GUEST",
    description:  "Explore our content to get started."
  },

  { rank: getRankImage(1),
    level: 100, 
    title:  "DEMO",
    description: "Introduction to Financial Markets",
    packageDescription: "desc.demo",
    packageFeatures: ["pf.demo.1"],
    contentItems: ["Introduction"],
    videos: [
      {group: 0, list: ["1.1.1.What is forex?", "1.1.2.What is a Commodity?", "1.1.3.What is an Index?", "1.1.4.What is a Share?", "1.1.5.What is a CFD?"]},
    ],
    docs: [
      {group: 0, 
        list: ["101-welcome-outline"]}
    ],
    utils: ["ecocalender"],
  },

  { rank: getRankImage(2),
    level: 200, 
    title: "STARTER",
    description: "Learning the basics description",
    packageDescription: "desc.starter",
    packageFeatures: ["pf.starter.1", "pf.starter.2"],
    contentItems: [ "Terminology"],
    videos: [
      {group: 0, list: ["1.2.1.Pips, Points, and Tricks", "1.2.2.Balance and Equity", "1.2.3.Bull and Bear Market", "1.2.4.Lots", "1.2.5.Bid and Ask Prices",
        "1.2.6.Short & Long Positions", "1.2.7.Stop Loss & Take Profit", "1.2.8.Pending Orders", "1.2.9.Leverage and Margin", "1.2.10.Chart Types"
      ]}
    ],
    docs: [
      {group: 0, list: ["101-welcome-outline"]},
    ],
    utils: ["currency-calculator"]
  },

  { rank: getRankImage(3),
    level: 300, 
    title: "JUNIOR" ,
    description: "Junir pack description",
    packageDescription: "desc.junior",
    packageFeatures: ["pf.junior.1", "pf.junior.2"],
    contentItems: ["Worst Mistakes Traders Make"],
    videos: [
      {group: 0, list: ["1.3.1.Trading Emotionally", "1.3.2.Averaging Down", "1.3.3.Trading Without Risk Control", "1.3.4.Not Following a Plan"]},
    ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline"]},
    ],
    utils: ["glossary"]
  },
  { rank: getRankImage(4),
    level: 400, 
    title: "BASIC",
    description: "Basic pack description",
    packageDescription: "desc.basic",
    packageFeatures: ["pf.basic.1", "pf.basic.2", "pf.basic.3"],
    contentItems: [ "ECN" ],
    videos: [
      {group: 0, list: ["1.4.1.What is ECN?","1.4.2.How are ECN Brokers Different?","1.4.3.Advantages of ECN"]}
    ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline"]},
    ],
    utils: []
  },

  { rank: getRankImage(5),
    level: 500, 
    title: "BEGINNER",
    description: "Beginner descript, Cryptocurrency fundamentals",
    packageDescription:  "desc.beginner",
    packageFeatures: ["pf.beginner.1", "pf.beginner.2"],
    contentItems: [ "Introduction To Crypto", "Cryptocurrencies"],
    videos: [
      {group: 0, list: ["2.1.1.What's a Cryptocurrency?", "2.1.2.Stablecoins","2.1.3.Blockchain","2.1.4.Mining","2.1.5.Staking","2.1.6.Coins and Tokens", "2.1.7.Forks"]},
      {group: 1, list: ["2.2.1.Bitcoin","2.2.2.Ethereum","2.2.3.Ripple","2.2.4.Tether","2.2.5.Dogecoin","2.2.6.Alternative Cryptocurrencies"]}
    ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
      {group: 1, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
    ],
    utils: [ ],
  },
  { rank: getRankImage(6),
    level: 600, 
    title: "INTERMEDIATE",
    description: "Intermediate - Crypto Trading & Investing - Technical Analysis essentials",
    packageDescription: "desc.intermediate",
    packageFeatures: ["pf.intermediate.1", "pf.intermediate.2", "pf.intermediate.3","pf.intermediate.4"],
    contentItems: ["Trading Crypto", "Investing in Crypto", "Storing Cryptocurrency", "Fundamental Analysis", "Technical Analysis", "Indicators"],
    videos: [
      {group: 0, list: ["3.1.1.To Trade or to Invest", "3.1.2.How to Trade Cryptocurrency", "3.1.3.Risks of Trading Crypto"]},
      {group: 1, list: ["3.2.1.How to Invest in Cryptocurrency","3.2.2.Risks of Investing in Crypto", "3.2.3.Ico", "3.2.4.Nft"]},
      {group: 2, list: ["3.3.1.What's a wallet", "3.3.2.Hot Wallet", "3.3.3.Cold Wallet", "3.3.4.How to Choose the Right Wallet"]},
      {group: 3, list: ["4.1.1.What is Fundamental Analysis?", "4.1.2.Economic Calendar?", "4.1.3.How to Apply an Economic Calendar"]},
      {group: 4, list: ["4.2.1.What is Technical Analysis?", "4.2.2.Support and Analysis", "4.2.3.How to Find Support and Resistance Levels", "4.2.4.Trend", 
        "4.2.5.How to Identify Trends", "4.2.6.Chart Time Frame"]},
      {group: 5, list: ["4.3.1.What's a Technical Indicator?", "4.3.2.Moving Average", "4.3.3.How to Apply Moving Averages", "4.3.4.MACD","4.3.5.How to Use MACD", 
        "4.3.6.Bollinger Bands", "4.3.7.How to Apply Bollinger Bands", "4.3.8.RSI", "4.3.9.How to Use RSI?"]}
    ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
      {group: 1, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
      {group: 2, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
      {group: 3, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
      {group: 4, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
      {group: 5, list: ["101-welcome-outline","cryptocurrency-fundamentals"]},
    ],
    utils: [ ],
  },

  { rank: getRankImage(7),
    level: 700, 
    title: "ADVANCED",
    description: "Advanced Technical Analysis",
    packageDescription: "desc.advanced",
    packageFeatures: ["pf.advanced.1", "pf.advanced.2"],
    contentItems: ["Chart Patterns", "Japanese Candlestick Patterns", "Fibonacci Trading", /* "Bonus Three High Probability Trading Setups" */],
    videos: [
      {group: 0, list: ["5.1.1.Cup and Handle", "5.1.2.How to Trade Cup and Handle", "5.1.3.Ascending and Descending Triangles", "5.1.4.How to Trade Ascending and Descending Triangles",
         "5.1.5.Rising and Falling Wedges", "5.1.6.How to Trade Rising and Falling Wedges", "5.1.7.Triple Top and Bottom", "5.1.8.How to Trade Triple Top and Bottom", "5.1.9.Head and shoulders", "5.1.10.How to Trade Head and Shoulders?"]},
      {group: 1, list: ["5.2.1.History of Japanese Candlestick Analysis", "5.2.2.Benefits of Using Candlesticks", "5.2.3.Candlestick Structure", "5.2.4.Doji", 
        "5.2.5.The Long-Legged Doji and the High Wave", "5.2.6.How to Trade the Long-Legged Doji and the High Wave", "5.2.7.The Gravestone Doji and the Dragonfly Doji",
        "5.2.8.How to Trade the Gravestone Doji and the Dragonfly Doji", "5.2.9.Shooting Star and Inverted Hammer", "5.2.10.How to Trade Shooting Star and Inverted Hammer", 
        "5.2.11.Dark Cloud Clover", "5.2.12.How to Trade Dark Cloud Cover", "5.2.13.Three White Soldiers and Three Black Crows", 
        "5.2.14.How to Trade Three White Soldiers and Three Black Crows", "5.2.15.Morning Star and Evening Star", "5.2.16.How to Trade Morning Star and Evening Star"
      ]},
      {group: 2, list: ["5.3.1.What is Fibonacci trading?", "5.3.2.How Reliable are Fibonacci Retracements", "5.3.3.How to Trade Fibonacci Retracements", 
        "5.3.4.How to Trade Fibonacci Extensions", "5.3.5.Fibonacci Trading Strategies", "5.3.6.Common Mistakes with Fibonacci Tools" ]},
      /* {group: 3, list: ["5.4.1.Three High Probability Trading Setups"]} */
    ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},
      {group: 1, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},
      {group: 2, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},

    ],
    utils: [ ],
  },

  { rank: getRankImage(8),
    level: 800, 
    title: "TRADER",
    description: "Trader Description",
    packageDescription: "desc.trader",
    packageFeatures: [ "pf.trader.1","pf.trader.2","pf.trader.3",  "pf.trader.4"],
    contentItems: ["MetaTrader 4", "MetaTrader 5", "MetaTrader 5 Iphone", "MetaTrader 5 Android"],
    videos: [
      {group: 0, list: ["7.1.1.Terminal Window", "7.1.2.Opening an Order", "7.1.3.Creating a Pending Order", "7.1.4.Closing an Order", 
        "7.1.5.Setting a Stop Loss and Take Profit", "7.1.6.Using a Trailing Stop", "7.1.7.One-Click Trading", "7.1.8.Adding Indicators to the Chart"]},
      {group: 1, list: ["7.2.1.What is New in MetaTrader 5", "7.2.2.Application Overview", "7.2.3.Creating a Demo Account", "7.2.4.Opening an Order", 
        "7.2.5.Creating a Pending Order", "7.2.6.Closing an Order", "7.2.7.Setting a Stop Loss and Take Profit", "7.2.8.Using a Trailing Stop", "7.2.9.One-Click Trailing",
        "7.2.10.Adding Indicators to the Chart", "7.2.11.Using Graphical Markup Tools", "7.2.12.Customizing Your Workspace", "7.2.13.Algorithmic Trading"]},
      {group: 2, list: ["7.3.1.Application Overview", "7.3.2.Logging in to an Existing Account", "7.3.3.Opening an Order", "7.3.4.Creating a Pending Order",
        "7.3.5.Closing an Order", "7.3.6.Setting a Stop Loss and Take Profit", "7.3.7.One-Click Trading", "7.3.8.Adding Indicators to the Chart"]},
      {group: 3, list: ["7.4.1.Application Overview", "7.4.2.Logging in to an Existing Account", "7.4.3.Opening an Order", "7.4.4.Creating a Pending Order",
        "7.4.5.Closing an Order", "7.4.6.Setting a Stop Loss and Take Profit", "7.4.7.One-Click Trading", "7.4.8.Adding Indicators to the Chart"]}
    ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},
      {group: 1, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},
      {group: 2, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},
      {group: 3, list: ["101-welcome-outline","cryptocurrency-fundamentals","advanced-technical-analysis"]},
    ],
    utils: [ ],
  },

  { rank: getRankImage(9),
    level: 900, 
    title: "ELITE",
    description: "Elite content displayed below",
    packageDescription: "desc.elite",
    packageFeatures: ["pf.elite.1", "pf.elite.2","pf.elite.3", "pf.elite.4" ],
    contentItems: ["Trading Strategies", "Elliott Wave Theory", "Harmonic Price Patterns"],
    videos: [
      {group: 0, list: ["6.1.1.What Is a Trading Strategy?", "6.1.2.The Pop 'n' Stop and Drop 'n' Stop", "6.1.3.How to Trade the Pop 'n' Stop and Drop 'n' Stop",
        "6.1.4.The Bladerunner", "6.1.5.How to Trade the Bladerunner", "6.1.6.Bolly Band Bounce", "6.1.7.How to Trade Bolly Band Bounce", "6.1.8.Daily Fibonacci Pivot",
        "6.1.9.How to Trade the Daily Fibonacci Pivot", "6.1.10.London Hammer", "6.1.11.How to Trade Market Opens", "6.1.12.The Forex Fractal", "6.1.13.How to Trade the Forex Fractal"
      ]},
      {group: 1, list: ["6.2.1.Introduction to Elliott Wave Theory", "6.2.2.Impulse Waves", "6.2.3.Corrective Waves", "6.2.4.Fractal Nature of Elliott Waves",
         "6.2.5.How to trade Elliott Waves", "6.2.6.Rules and Tips for Using Elliott Waves"
      ]},
      {group: 2, list: ["6.3.1.What are Harmonic Price Patterns", "6.3.2.The ABCD Pattern", "6.3.3.The Gartley Pattern", "6.3.4.The BAT Pattern", "6.3.5.The Crab Pattern",
        "6.3.6.The Butterfly Pattern", "6.3.7.The Shark Pattern", "6.3.8.The Cypher Pattern", "6.3.9.The Three Drives Pattern", "6.3.10.The Wolfe Waves Pattern"]}
    ],
    docs: [ 
      {group: 0, list: [,"advanced-technical-analysis"]},
      {group: 1, list: [,"advanced-technical-analysis"]},
      {group: 2, list: [,"advanced-technical-analysis"]},
    ],
    utils: [ ],
  },

  { rank: getRankImage(10),
    level: 1000, 
    title: "PRO",
    description: "Professional Package",
    packageDescription: "desc.pro",
    packageFeatures: ["pf.pro.1", "pf.pro.2"],
    contentItems: [],
    videos: ["video601" ],
    docs: ["101-welcome-outline","advanced-technical-analysis"],
    utils: [ ],
  },  
  { rank: getRankImage(11),
    level: 1100, 
    title: "SENIOR",
    description: "Senior package is the most sophisticated package presented to anyone wants to be literate in finance",
    packageDescription: "desc.senior",
    packageFeatures: ["pf.senior.1", "pf.senior.2", "pf.senior.3"],
    contentItems: [],
    videos: ["video601" ],
    docs: [ 
      {group: 0, list: ["101-welcome-outline","advanced-technical-analysis"]},
    ],
    utils: ["" ],
  },
  { level: 9999, title: "Welcome to the VixAcademy Admin Dashboard !",
    description: "Admin panel where user ranks can be changed, user accounts can be deleted, content can be edited?",
    videos: ["adminTutorial"],
    docs: ["adminGuide"],
    utils: ["userManager"]
  }
]



/*🚀*/ // senior  student05@t.com test123
/* admin admin123 */